import * as api from "app/api/users"
import { getCurrentToken } from "app/redux/authorization/authorization.selectors"
import { SagaIterator } from "redux-saga"
import { call, put, select, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import pick from "lodash.pick"
import * as actions from "./currentUser.actions"
import { setDocumentLanguage } from "../utils"

const endpoint = "users"
const service = "users"

export function* getCurrentUserFlow(): SagaIterator {
  try {
    const currentToken = yield select(getCurrentToken)
    const response = yield call(api.getUsersById, currentToken.id!)
    const {
      data,
      data: { locale, settings },
    } = response
    yield put(actions.getCurrentUserSuccess(data))
    yield put(
      actions.putUserSettingsSuccess(
        pick(settings, ["hide_weekend", "hide_time", "hide_warnings", "horizontal_scale"]),
      ),
    )
    yield call(setDocumentLanguage, locale)
  } catch (e) {
    yield put(actions.getCurrentUserFail(e))
    yield call(handleError, { endpoint, service, error: e })
  }
}

export function* putUserSettingsFlow(action: actions.PutUserSettingsAction): SagaIterator {
  try {
    const { data } = action.payload
    yield call(api.putUserSettings, data)
    yield put(actions.putUserSettingsSuccess(data))
  } catch (e) {
    yield put(actions.putUserSettingsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* currentUserSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET_CURRENT_USER, getCurrentUserFlow)
  yield takeLatest(actions.Types.PUT_USER_SETTINGS, putUserSettingsFlow)
}
